<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/jala-investor-user";
import { serialize } from "object-to-formdata";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit JALA Trade Users",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_investor_users.singular')) }},
    resourceRoute: {default: 'jala_investor_users'},
    modelVariable: {default: 'jala_investor_user'},
    form: {default() { return FormsModel; }},
    denyDelete: {type: Boolean, default: true}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_investor_users.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('jala_investor_users.plural')),
          href: "/jala_investor_users",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/jala_investor_users/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/jala_investor_users/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    getModelName() {
      return (this.model.user || {}).email || this.getModelKey();
    },
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/jala/investor_users/${this.$route.params.key}`, {
        params: { with: 'user' }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      const { user: { avatar, ...user } } = value
      return this.$axios.put(`/jala/investor_users/${this.$route.params.key}`, {
        ...value,
        user: {
          ...user,
          avatar: (typeof avatar !== 'string' && !avatar) ? avatar : undefined
        }
      })
        .then((response) => {
          const { data: { data } } = response;
          const files = {};
          if (avatar && typeof avatar !== 'string') files.avatar = avatar;
          if (this.lodash.isEmpty(files)) return response;
          return this.$axios.post(`jala/investor_users/${data.id}`, (
            serialize({user: {id: data.user_id, ...files}, _method: 'PUT'})
          )).then(() => response).catch(() => response);
        })
    },
    delete() {
      return this.$axios.delete(`/jala/investor_users/${this.$route.params.key}`)
    }
  }
}
</script>
